import React from "react";
import { SpaceProps } from "styled-system";

import { useRaceTracksFilter } from "@urp/lib-racetracks";
import { FilterButtonBar, FilterButton } from "@tvg/design-system/web/";
import { FilterContainer, FilterLabel } from "./styled-components";
import TracksFilterMask from "./TracksFilterMask";

interface RaceTracksFilterProps extends SpaceProps {
  currentTab: string;
  isRaceTypesFilterEnabled?: boolean;
  loading?: boolean;
}

export const RaceTracksFilter = ({
  currentTab,
  isRaceTypesFilterEnabled = true,
  loading = false,
  ...rest
}: RaceTracksFilterProps) => {
  const {
    tracksFilterMsg,
    raceTypesFilter,
    regionsFilter,
    handleRaceTypeChange,
    handleRegionChange
  } = useRaceTracksFilter();

  if (loading) {
    return <TracksFilterMask />;
  }

  return (
    <FilterContainer {...rest}>
      <div>
        <FilterLabel>{tracksFilterMsg.raceTypes.title}</FilterLabel>
        <FilterButtonBar
          qaLabel="filterButtonBar-raceType"
          isDisabled={!isRaceTypesFilterEnabled}
          activeButtons={raceTypesFilter}
          onButtonClick={(raceType: string) =>
            handleRaceTypeChange(raceType, currentTab)
          }
          mt="space-1"
        >
          {tracksFilterMsg.raceTypes.options.map((filterOption) => (
            <FilterButton
              key={filterOption.value}
              value={filterOption.value}
              qaLabel={`raceType-${filterOption.value}`}
            >
              {filterOption.label}
            </FilterButton>
          ))}
        </FilterButtonBar>
      </div>
      <div>
        <FilterLabel data-qa-label="filterLabel-region">
          {tracksFilterMsg.regions.title}
        </FilterLabel>
        <FilterButtonBar
          qaLabel="filterButtonBar-region"
          activeButtons={regionsFilter}
          onButtonClick={(raceType: string) =>
            handleRegionChange(raceType, currentTab)
          }
          mt="space-1"
        >
          {tracksFilterMsg.regions.options.map((filterOption) => (
            <FilterButton
              key={filterOption.value}
              value={filterOption.value}
              qaLabel={`region-${filterOption.value}`}
            >
              {filterOption.label}
            </FilterButton>
          ))}
        </FilterButtonBar>
      </div>
    </FilterContainer>
  );
};

export default RaceTracksFilter;
